(function ($, Drupal, drupalSettings) {
  'use strict';

  Drupal.behaviors.GoBanner = {
    attach: function attach(context, settings) {
      var $goBanner = $('.go-banner', context);
      var $button = $('.go-banner .coh-link', context);

      if (!$goBanner.length) {
        return;
      }

      // Only initialize once
      if ($button.data('go-banner-initialized')) {
        return;
      }
      $button.data('go-banner-initialized', true);

      // Setup initial styles
      $('body').addClass('quick-exit-button');
      $button.attr('tabindex', '1');
      $('.skip-link').attr('tabindex', '2');
      $(".master-template-footer").css('paddingBottom', ($goBanner.innerHeight() - 1));

      var goUrl = $button.attr('href');
      var keypressCounter = 0;
      var lastKeyWasModified = false;
      var timeoutTime = 5000;
      var keypressTimeoutId = null;
      var timeoutMessageId = null;
      var $overlay = null;
      var $updateSpan = null;
      var $indicatorContainer = null;
      var gestureAllowed = false;

      document.addEventListener('pointerdown', () => gestureAllowed = true, { once: true });

      // Create screen reader announcement span
      function initUpdateSpan() {
        $updateSpan = $('<span></span>')
          .attr('role', 'status')
          .addClass('visually-hidden')
          .appendTo($goBanner);
      }

      // Create three indicator lights
      function buildIndicator() {
        $indicatorContainer = $('<div></div>')
          .addClass('go-banner-indicator')
          .attr('aria-hidden', 'true');

        for (var i = 0; i < 3; i++) {
          $('<div></div>')
            .addClass('go-banner-indicator-light')
            .appendTo($indicatorContainer);
        }

        $button.append($indicatorContainer);
      }

      // Update indicator lights visibility and state
      function updateIndicator() {
        if (!$indicatorContainer) {
          return;
        }

        $indicatorContainer.toggleClass('go-banner-indicator--visible', keypressCounter > 0);

        $indicatorContainer.find('.go-banner-indicator-light').each(function(index) {
          $(this).toggleClass('go-banner-indicator-light--on', index < keypressCounter);
        });
      }

      // Exit the page with loading overlay
      function exitPage() {
        if ($updateSpan) {
          $updateSpan.text('');
        }

        // Create white overlay to blank the page
        $('body').addClass('go-banner-hide-content');
        $overlay = $('<div></div>')
          .addClass('go-banner-overlay')
          .attr('role', 'alert')
          .appendTo('body');

        // Add text after appending for better screen reader support
        $overlay.text('Loading.');

        if (gestureAllowed) {
          // Open new tab with user's URL
          window.open(goUrl, '_newtab'); // Navigate current tab to Google

          window.location.replace('http://google.com');
        } else {
          window.location.replace(goUrl);
        }
      }



      // Start/restart the keypress timer
      function setKeypressTimer() {
        if (keypressTimeoutId) {
          window.clearTimeout(keypressTimeoutId);
        }

        keypressTimeoutId = window.setTimeout(resetKeypressTimer, timeoutTime);
      }

      // Reset keypress counter and timer
      function resetKeypressTimer() {
        if (!$updateSpan) {
          return;
        }

        if (keypressTimeoutId) {
          window.clearTimeout(keypressTimeoutId);
          keypressTimeoutId = null;
        }

        keypressCounter = 0;
        $updateSpan.text('Exit this page expired.');

        timeoutMessageId = window.setTimeout(function() {
          $updateSpan.text('');
        }, timeoutTime);

        updateIndicator();
      }

      // Handle Shift key presses (triple press to exit)
      function handleKeypress(event) {
        if (!$updateSpan) {
          return;
        }

        // Only respond to standalone Shift key presses
        if (event.key === 'Shift' && !lastKeyWasModified) {
          keypressCounter += 1;


          updateIndicator();

          if (timeoutMessageId) {
            window.clearTimeout(timeoutMessageId);
            timeoutMessageId = null;
          }

          if (keypressCounter >= 3) {
            keypressCounter = 0;

            if (keypressTimeoutId) {
              window.clearTimeout(keypressTimeoutId);
              keypressTimeoutId = null;
            }

            exitPage();
          } else {
            if (keypressCounter === 1) {
              $updateSpan.text('Shift, press 2 more times to exit.');
            } else {
              $updateSpan.text('Shift, press 1 more time to exit.');
            }
          }

          setKeypressTimer();
        } else if (keypressTimeoutId) {
          // Reset if user presses any other key
          resetKeypressTimer();
        }

        lastKeyWasModified = event.shiftKey;
      }

      // Reset page state (handles browser back button)
      function resetPage() {
        $('body').removeClass('go-banner-hide-content');

        if ($overlay) {
          $overlay.remove();
          $overlay = null;
        }

        if ($updateSpan) {
          $updateSpan.attr('role', 'status').text('');
        }

        updateIndicator();

        if (keypressTimeoutId) {
          window.clearTimeout(keypressTimeoutId);
        }

        if (timeoutMessageId) {
          window.clearTimeout(timeoutMessageId);
        }
      }

      // Initialize components
      initUpdateSpan();
      buildIndicator();

      // Button click handler
      $button.on('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        exitPage();
      });

      $goBanner.on('click', function() {
        exitPage();
      });

      // Keypress handler (only bind once globally)
      if (!document.body.dataset.goBannerKeypressInitialized) {
        $(document).on('keyup', handleKeypress);
        document.body.dataset.goBannerKeypressInitialized = 'true';
      }

      // Handle browser back button
      $(window).on('pageshow', resetPage);
    },
  };
})(jQuery, Drupal, drupalSettings);
